import React from 'react'
import { Dropdown,toast,Notification } from 'components/ui'
import { 
	HiOutlineSwitchHorizontal, 
	HiOutlineFlag,
	HiOutlineCog,
	HiOutlinePrinter,
	HiOutlineMap,
	HiOutlinePencil
} from 'react-icons/hi'
import EllipsisButton from 'components/shared/EllipsisButton'
import { useNavigate } from 'react-router-dom'

import { printRoute} from '../../../../api/planningroutes'



const dropdownList = [
	{ label: 'Add Flag', value: 'addFlag', icon: <HiOutlineFlag/>},
	{ label: 'Move', value: 'move', icon: <HiOutlineSwitchHorizontal/>},
	{ label: 'Setting', value: 'planningSetting', icon: <HiOutlineCog/>}
]

const ItemDropdown = (props) => {

	const{Routeid,_id}=props;

			const navigate = useNavigate()
		
			const onEdit = () => {
				navigate(`/app/logistics/planning-edit/${_id}`)
			}

				const openInNewTab = (url) => {
					//target="_top"
					setTimeout(() => {
						toast.push(
							<Notification title={"Documento impreso"} type="success" duration={5000}>
								Documento impreso exitosamente
							</Notification>
							,{
								placement: 'top-center'
							}
						)
						window.open(url, '_top');
			//window.location.assign(url)
				
					})
					//window.open(url, "_blank", "noreferrer");
				  };
				  
			//on print order
			const onPrint = async () => {
				toast.push(
					<Notification title={"Imprimiendo ruta"} type="info" duration={5500}>
						Por favor espere
					</Notification>
					,{
						placement: 'top-center'
					}
				)
				const success = await printRoute(_id)
			
				const url = success._bodyText.slice(1, -1);
			
				console.log(url)
				if (!url.includes("Error")) {
			
				
			
					openInNewTab(url)
				}else{
					toast.push(
						<Notification title={"Error al imprimir"} type="danger" duration={5000}>
							{url}
						</Notification>
						,{
							placement: 'top-center'
						}
					)
				}
			}
	return (
		<Dropdown 
			placement="bottom-end" 
			renderTitle={<EllipsisButton />}
		>
			
		
					<span className="ml-2 rtl:mr-2">ID: {Routeid}</span>
				
			<Dropdown.Item eventKey={Math.random()} key={Math.random()} onClick={onPrint}>
					<span className="text-lg"><HiOutlinePrinter/></span>
					<span className="ml-2 rtl:mr-2">Hoja de ruta</span>
				</Dropdown.Item>
				{/* <Dropdown.Item eventKey={Math.random()} key={Math.random()}>
					<span className="text-lg"><HiOutlineFlag/></span>
					<span className="ml-2 rtl:mr-2">Marcar como finalizada</span>
				</Dropdown.Item> */}
				<Dropdown.Item eventKey={Math.random()} key={Math.random()} onClick={onEdit}>
					<span className="text-lg"><HiOutlinePencil/></span>
					<span className="ml-2 rtl:mr-2">Editar</span>
				</Dropdown.Item>
	
		</Dropdown>
	)
}

export default ItemDropdown
